'use client';

import { useEffect } from 'react';
import { useAddressStore } from '@/stores/address-store';
import { useCheckoutStore } from '@/stores/checkout-store';

/**
 * Возвращает человека в корзину после того, как он указал адрес.
 *
 * Сценарий: нажал «Корзина» без адреса → гейт в openCheckout развернул выбор
 * адреса → человек подтвердил. Без этого компонента он остался бы просто на
 * странице каталога, не понимая, куда делась корзина.
 *
 * Флаг взводит только confirmSheet (кнопка подтверждения). Закрытие крестиком,
 * оверлеем или Esc идёт через closeSheet и корзину НЕ открывает — иначе гейт
 * стал бы ловушкой: передумал смотреть корзину, а тебя туда всё равно втащило.
 *
 * Отдельного «бэкстопа на открытие корзины» здесь намеренно нет: корзину
 * открывает единственный экшен openCheckout, в нём гейт и стоит. Дублировать
 * проверку на уровне рендера нельзя — на сервере адреса не видно, и первый
 * кадр разошёлся бы с серверным.
 */
export function CheckoutAddressGate() {
  const resumeCheckout = useAddressStore((s) => s.resumeCheckout);

  useEffect(() => {
    if (!resumeCheckout) return;

    // Сбрасываем флаг до открытия: openCheckout синхронный, и повторный
    // прогон эффекта не должен открыть корзину второй раз.
    useAddressStore.getState().consumeResumeCheckout();

    // Адрес уже сохранён, поэтому гейт внутри пропустит.
    useCheckoutStore.getState().openCheckout();
  }, [resumeCheckout]);

  return null;
}
